var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"never"}},[_c('pdf',{ref:"pdf",attrs:{"src":_vm.source,"page":_vm.page},on:{"num-pages":function($event){_vm.totalPages = $event},"link-clicked":function($event){_vm.page = $event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0a05b9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreviewPdf.vue
// module id = null
// module chunks = 